export default "__VITE_ASSET__BPczP$1k__"